
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { FormContext } from 'core/FormProvider';


const StyledFormControl = styled(FormControl)`
  .MuiFormControl-root { margin-bottom: 0 !important; }
`;


export class ContextWidget extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    WidgetComponent: PropTypes.any,
    widgetProps: PropTypes.object
  };

  render() {
    const { name, WidgetComponent, widgetProps } = this.props;
    return (
      <FormContext.Consumer>
        {context => {
          const hasError = context.hasFieldError(name);
          const value = context.getValue(name);
          let errorText = undefined;

          if (hasError) {
            errorText = context.getFieldErrorText(name);
          }

          return (
            <React.Fragment>
              {WidgetComponent && (
                <WidgetComponent
                  error={hasError}
                  name={name}
                  value={value}
                  fullWidth={true}
                  onChange={(value) => context.setValue(name, value)}
                  helperText={errorText}
                  {...widgetProps}
                />
              )}
              {this.props.children && this.props.children}
            </React.Fragment>
          )
        }}
      </FormContext.Consumer>
    )
  }
}


export class ContextFormControlWidget extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    WidgetComponent: PropTypes.any,
    widgetProps: PropTypes.object
  };

  static defaultProps = {
    required: false
  };

  render() {
    const { name, required, label, WidgetComponent, size, widgetProps } = this.props;
    return (
      <FormContext.Consumer>
        {context => {
          const errorText = context.getFieldErrorText(name);
          const hasError = context.hasFieldError(name);
          const value = context.getValue(name);
          return (
            <StyledFormControl fullWidth={true} error={hasError} required={required} size={size} variant="outlined">
              {label && (<InputLabel>{label}</InputLabel>)}
              {WidgetComponent && (
                <WidgetComponent
                  name={name}
                  value={value}
                  onChange={(value) => context.setValue(name, value)}
                  helperText={errorText}
                  {...widgetProps}
                />
              )}
              {this.props.children && this.props.children}
              {errorText && (<FormHelperText>{errorText}</FormHelperText>)}
            </StyledFormControl>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
